var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "cardContent" }, [
    _c("div", { staticClass: "table-box" }, [
      _vm._m(0),
      _c(
        "div",
        {
          staticClass: "tableBody",
          on: {
            click: function ($event) {
              $event.stopPropagation()
              return _vm.handleSectionClick($event)
            },
          },
        },
        [
          _c(
            "vue-seamless-scroll",
            {
              staticStyle: { height: "100%" },
              attrs: { data: _vm.tableData, "class-option": _vm.classOption },
            },
            [
              _c(
                "ul",
                _vm._l(_vm.tableData, function (item, index) {
                  return _c(
                    "li",
                    {
                      key: index,
                      staticClass: "flex content",
                      attrs: { "data-id": item.id },
                    },
                    [
                      _c("div", { staticStyle: { width: "12%" } }, [
                        _vm._v(_vm._s(index + 1)),
                      ]),
                      _c("div", { staticStyle: { width: "30%" } }, [
                        _vm._v(_vm._s(item.name)),
                      ]),
                      _c("div", { staticStyle: { width: "40%" } }, [
                        _vm._v(" " + _vm._s(item.orgCompanyName) + " "),
                      ]),
                      _c("div", { staticStyle: { width: "18%" } }, [
                        _vm._v(" " + _vm._s(item.completion) + " "),
                      ]),
                    ]
                  )
                }),
                0
              ),
            ]
          ),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "tableTitle flex" }, [
      _c("div", { staticStyle: { width: "12%" } }, [_vm._v("序号")]),
      _c("div", { staticStyle: { width: "30%" } }, [_vm._v("名称")]),
      _c("div", { staticStyle: { width: "40%" } }, [_vm._v("承担单位")]),
      _c("div", { staticStyle: { width: "18%" } }, [_vm._v("建设进度")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }